import devChangeEmployeeMobileComponent from './devChangeEmployeeMobile.component';

let devChangeEmployeeMobileModule = angular.module('components.devChangeEmployeeMobile', [])

.component('devChangeEmployeeMobile', devChangeEmployeeMobileComponent)

.name;

export default devChangeEmployeeMobileModule;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/devChangeEmployeeMobile/devChangeEmployeeMobile.js